export default __webpack_public_path__ + "static/media/Navadhan_Logo.b16dc825.png";